import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
//import axios from "axios";
//import VueAxios from "vue-axios";


Vue.config.productionTip = false;
//Vue.prototype.$axios = axios;

new Vue({
  router,
  store,
  //VueAxios,
  //axios,
  render: h => h(App)
}).$mount("#app");
